var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "104px",
    viewBox: "0 0 104 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 52,
    cy: 52,
    r: 52
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile---Billing---Subscription",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KA---14c-Confirmation-Copy",
    transform: "translate(-762.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illus/160px/Success",
    transform: "translate(762.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#8AE6C7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.530330, 44.966726) rotate(-45.000000) translate(-52.530330, -44.966726) translate(23.030330, 22.966726)",
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.438827, 0.438827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11384261,5.20988491 C12.2165293,5.20988491 15.542414,8.53576963 15.542414,12.6384563 L15.5423212,27.4951349 L45.2566998,27.4955992 C49.3593865,27.4955992 52.6852712,30.8214839 52.6852712,34.9241706 C52.6852712,39.0268573 49.3593865,42.3527421 45.2566998,42.3527421 C30.3209758,42.3527421 19.1191829,42.3527421 11.6513209,42.3527421 C5.32027923,42.3527421 0.685271183,37.717734 0.685271183,31.5096149 C0.685271183,27.3160241 0.685271183,21.0256379 0.685271183,12.6384563 C0.685271183,8.53576963 4.0111559,5.20988491 8.11384261,5.20988491 Z",
    id: "Path-Copy",
    fill: "#14CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5717154,0.385427491 C16.6744021,0.385427491 20.0002868,3.71131221 20.0002868,7.81399892 L20.0001939,22.6706775 L49.7145725,22.6711418 C53.8172592,22.6711418 57.1431439,25.9970265 57.1431439,30.0997132 C57.1431439,34.2023999 53.8172592,37.5282846 49.7145725,37.5282846 L12.5717154,37.5282846 C8.46902865,37.5282846 5.14314394,34.2023999 5.14314394,30.0997132 L5.14314394,7.81399892 C5.14314394,3.71131221 8.46902865,0.385427491 12.5717154,0.385427491 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.9bd9b90b55c532ed06da939e04882589.svg";
export { ForwardRef as ReactComponent };